module.exports = __webpack_public_path__ + "03c10a0e89c044c544a3d91324804a1b.MP3";